module.exports = __webpack_public_path__ + "img/background-lite original.d8c59fb3.png";